<!--EChart图表组件-->
<template>
  <div :id="chartid" class="default-chart">
  </div>
</template>
<script>
  import * as echarts from "echarts";
  import $ from 'jquery';
  export default {
    components: {},
    props: {
      themes: undefined //主题，默认从皮肤配置中获取
    },
    data() {
      return {
        chartid: this.randomPkid(),
        mychart: {},
        options: {},
        chartBody: undefined
      }
    },
    created() { },
    mounted() {
      
      //初始化页面
      this.chartBody = document.getElementById(this.chartid)
      if (this.themes != undefined) {
        this.mychart = echarts.init(this.chartBody, this.themes, {
          renderer: 'canves'
        })
      } else {
        this.mychart = echarts.init(this.chartBody, '', {
          renderer: 'canves'
        })
      }
      this.mychart.on("click", params => {
        this.$emit("itemselect", params)
      })
      //类型切换事件
      this.mychart.on("magictypechanged", params => {
        this.$emit("typechanged", params)
      })
      var lastWidth = 0

      if (this.mychart) {
         setTimeout(() => {
          this.mychart.resize();
          // console.log(111111111);
         }, 900);
        $(window).resize(() => {
          this.mychart.resize()
        });

      }
    },
    updated() {
      if (this.mychart) {
        this.mychart.resize()
      }
    },
    beforeDestroy() {
      this.mychart.clear()
    },
    destroyed() {
      if (this.mychart) {
        this.mychart.resize()
      }
      this.removeTask(this.chartid)
    },

    watch: {},
    methods: {
      removeTask(tag) {
        if (tag) {
          clearInterval(tag);
        }
      },
      randomPkid(len) {
        if (!len) {
          len = 32
        }
        var randomstring = ""
        var charlist = "0123456789qwertyuiopasdfghjklzxcvbnm"
        for (var i = 0; i < len; i++) {
          randomstring += charlist[Math.ceil(Math.random() * 35)]
        }
        return randomstring
      },
      setData(options, shouldClear) {
        this.options = options
        if (shouldClear == true) {
          this.mychart.setOption(options, true)
          return
        }
        this.mychart.setOption(options)
      },
      getOptions() {
        return this.options
      },
      getDefaultOptions() {
        return {
          // title: {
          //   text: "数据曲线",
          //   left: 'center',
          // },
          toolbox: {
            show: true,
            feature: {
              magicType: {
                type: ['line', 'bar'],
                iconStyle: {
                  borderColor: '#22bb22'
                },
              },
            },
            right: '5%',
            top: '5%'
          },
          tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: (params, ticket, callback) => {
              var label = params[0].data[0] + "</br>"
              if (params[0].axisType == "xAxis.time") {
                //时间类型
                label = new Date(params[0].data[0]).formatByTime() + "</br>"
              }

              params.forEach(item => {
                var values;
                if (isnull(item.data[1])) {
                  values = "无采集数据";
                } else {
                  values = cutDigital(item.data[1]);
                }
                label += item.seriesName + " : " + values + "</br>"
              })
              return label;
            },
            axisPointer: {
              animation: true
            }
          },
          xAxis: {
            type: 'category',
          },
          yAxis: {
            type: 'value',
            max: value => {
              var max = parseFloat(value.max)
              if (max < 1) {
                return 1
              }
              if (max < 100) {
                return parseInt(value.max) + 1
              }
              return parseInt(max * 1.1)
            },
            boundaryGap: [0, '100%'],
            splitLine: {
              show: false
            }
          },
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100
          }],
          grid: {
            left: '6%',
            right: '5%',
            bottom: '100',
            containLabel: true
          },
          legend: {
            data: [],
            type: 'scroll',
            bottom: '40px',
            formatter: function (name) {
              return echarts.format.truncateText(name, 100, '14px Microsoft Yahei', '…');
            },
            tooltip: {
              show: true
            },
            selected: {}
          },
          series: []
        }
      }
    }
  }
</script>

<style scoped>
  .default-chart {
    width: 100%;
    height: 6rem;
  }
</style>